export default __webpack_public_path__ + "static/media/asa.38957b04.jpeg";